import {useQuery} from "react-query";
import {Organisation} from "../types/Organisation";
import {Option} from "../components/Form/Form/Control";
import SponsorType from "../types/SponsorType";
import IconName from "../types/IconName";
import {User} from "../types/User";
import ngage from "../services/ngage";
import {Sponsor} from "../types/Sponsorship";

// Helpers ----

function organisationAsOption(organisation: Organisation): Option {
  return {
    type: SponsorType.ORGANISATION,
    id: organisation.id,
    name: organisation.name,
    description: organisation.email,
    icon: IconName.GLOBE_ALT
  }
}

function userAsOption(user: User): Option {
  return {
    type: SponsorType.USER,
    id: user.id,
    name: user.name,
    description: user.email,
    icon: IconName.USER
  }
}

async function fetchSponsors(search?: string | null): Promise<Array<Option>> {
  const sponsors = await Promise.all([
    ngage.organisations.filtered({search}).then(page => page?.data || []),
    ngage.users.filtered({search}).then(page => page?.data || []),
  ])

  const options: Array<Option> = []

  options.push(...sponsors[0].map(organisationAsOption))
  options.push(...sponsors[1].map(userAsOption))

  return options
}

export function sponsorAsOption (sponsor: Sponsor): Option | null {
  return "has_logged_in" in sponsor ? userAsOption(sponsor) : organisationAsOption(sponsor);
}

// Hook ----

export default function useSponsorOptions(searchTerm?: string | null) {
  return useQuery(
    ['sponsors', {searchTerm}],
    () => fetchSponsors(searchTerm),
    {keepPreviousData: true}
  )
}